// Section 8 and 9: Builder. 3 build points into the top of the build queue. Hammer 1.4x;
// 4% injury. Heavy job (+0.2 food demand). Constants: config.jobs.builder.
import type { Config } from '../../config';
import { alwaysEligible, heavyJobDemand } from '../../core/content-helpers';
import { defineJob } from '../../core/registry';

export function builder(config: Config) {
  const c = config.jobs.builder;

  return defineJob({
    id: 'builder',
    label: 'Builder',
    section: 'S8',
    heavy: true,
    output: { kind: 'service', service: 'buildPoints' },
    baseYield: c.yield,
    toolFactor: c.toolFactor,
    toolWear: 0,
    risks: { injury: c.injury },
    riskIllness: null,
    requiresBuilding: null,
    minStrength: 0,
    modifierTargets: ['demand'],
    modifierKeys: { demand: ['food'] },
    modifiers: heavyJobDemand('builder', config.needs.heavyJobFoodSurcharge),
    produce: (_ctx, _worker, output) =>
      output > 0 ? [{ kind: 'service', service: 'buildPoints', amount: output }] : [],
    eligible: alwaysEligible,
  });
}
